module.exports = __webpack_public_path__ + "static/img/lap04.e31c99d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/lap04.png
// module id = IUQ3
// module chunks = 11